import './footer.scss';

export default function Footer() {
  return (
    <footer className="footer">
      <small className="footer__copyright">@ sotobayashi.work</small>
    </footer>
  );
}
